import * as React from 'react';
import styled from 'styled-components';
import { colors } from 'utils/colors';

interface NavLinkWrapperProps {
  isActive: boolean;
}

export const NavLinkWrapper = styled.a<NavLinkWrapperProps>`
  display: block;
  position: relative;
  color: ${({ isActive }) => (isActive ? colors.SECONDARY : colors.WHITE)};
  text-decoration: none;
  transition: all 0.15s ease-out;
  font-size: 14px;

  @media screen and (min-width: 600px) {
    font-size: 16px;
  }

  &:hover {
    color: ${colors.SECONDARY};
    &::after {
      width: 100%;
    }
  }

  &::after {
    position: absolute;
    content: '';
    left: 0;
    bottom: -5px;
    height: 2px;
    width: ${({ isActive }) => (isActive ? '100%' : 0)};
    background: ${colors.SECONDARY};
    transition: all 0.15s ease-out;
  }
`;

interface NavLinkProps extends React.HTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: React.ReactNode;
  isActive?: boolean;
  onAnchorHandler?: (elementId: string) => void;
}

export const NavLink: React.FC<NavLinkProps> = ({
  href,
  children,
  isActive = false,
  onAnchorHandler,
  ...props
}) => {
  const isAnchorLink = href.indexOf('#') === 0;
  const elementId = href.slice(1);
  let scrollElement: HTMLElement;
  const onClickHandler = () => {
    if (isAnchorLink) {
      if (!scrollElement) {
        scrollElement = document.getElementById(elementId);
      }
      event.preventDefault();

      if (onAnchorHandler) {
        onAnchorHandler(elementId);
      }

      window.scrollTo({
        top: scrollElement.offsetTop - 64,
        behavior: 'smooth',
      });
    }
  };

  return (
    <NavLinkWrapper href={href} onClick={onClickHandler} isActive={isActive} {...props}>
      {children}
    </NavLinkWrapper>
  );
};
